import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { observer } from 'mobx-react-lite'
import { NavbarWrapper } from './Navbar'
import { colors, device, fontSize, spacing } from '../styles/_var'
import icon from '../assets/images/icon.png'
import Text from './Text'
import uiStore from '../stores/uiStore'
import authStore from '../stores/authStore'
import { NavUserInfo } from './NavUserInfo'
import creditStore from '../stores/creditStore'
import { IVisibility } from '../utils/interfaces'
import { capitalize } from '../utils/helpers'
import competitionStore from '../stores/competitionStore'

interface IVoterNavbar {
  competitionPlan?: number,
  visibility?: IVisibility
}


const VoterNavbar: FunctionComponent<IVoterNavbar> = ({
  competitionPlan,
  visibility
}) => {
  const subscriptionType = competitionPlan !== undefined ? competitionStore.getPlanByCode(competitionPlan) : undefined
  const visibilityColor: Record<IVisibility, string> = {
    "public_visibility": colors.darkyellow,
    "private_visibility": colors.lightpurple
  }

  return (
    <Navbar hideShadow={false}>
      <NavTitle>
        <img src={icon} alt='' />
        <Text variant="large" role="heading" truncate>
          {uiStore.voterNavTitle}
        </Text>
        {competitionPlan !== undefined && (
          <Label color={subscriptionType?.label_color}>
            {subscriptionType?.slug}
          </Label>
        )}
        {visibility && (
          <Label color={visibilityColor[visibility]} textColor={colors.white}>
            {capitalize(visibility.replace('_visibility', ' '))}
          </Label>
        )}
      </NavTitle>
      <NavUserInfo
        avatar={authStore.userAvatar}
        firstName={authStore.userFirstName}
        tushCredits={creditStore.creditBalance}
        toggleSidebar={() => uiStore.toggleSidebar()}
      />
    </Navbar>
  )
}

export default observer(VoterNavbar)

const Navbar = styled(NavbarWrapper)`
  position: relative;
  height: 10rem;
  padding: 0 ${spacing.sm};
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media ${device.tablet} {
    height: 8rem;
  }
`

const NavTitle = styled.div`
  display: flex;
  img {
    height: 3.5rem;
    margin-right: ${spacing.xxs};

    @media ${device.tablet} {
      display: none;
    }
  }
`

const Label = styled(({ color, textColor, ...rest }) => <span {...rest} />)`
  ${({ color }) => color && `
    background-color: ${color};
  `}
  ${({ textColor }) => !!textColor ? `
    color: ${textColor};
  ` : `
    color: ${colors.darkyellow};
  `}
  padding: 0.5rem 1rem;
  height: 1.6rem;
  display: flex;
  align-items: center;
  margin-left: 5px;
  font-family: Gilroy-bold;
  border-radius: 0.3rem;
  font-size: ${fontSize.xs}
`